import React from "react";

/**
 * MetricsBand — banda de KPIs configurables desde admin.
 * Si no hay métricas, devuelve null (sección se oculta).
 */
export function MetricsBand({ metrics }) {
  if (!metrics || metrics.length === 0) return null;

  const unitSuffix = (unit) => {
    if (unit === "hours") return " h";
    if (unit === "percent") return " %";
    return "";
  };

  const gridCols =
    metrics.length <= 2
      ? "sm:grid-cols-2"
      : metrics.length === 3
        ? "sm:grid-cols-3"
        : "sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4";

  return (
    <section
      className="border-b border-gray-200 bg-brand-cream-soft relative overflow-hidden"
      data-testid="landing-metrics-section"
    >
      <div className="absolute inset-0 dot-pattern opacity-30 pointer-events-none" aria-hidden="true" />
      <div className="relative container-prose py-14">
        <div className="text-center max-w-2xl mx-auto mb-10">
          <p className="text-xs uppercase tracking-[0.22em] text-brand-coral font-semibold mb-3">
            Procure en números
          </p>
          <h2 className="font-serif text-2xl sm:text-3xl text-gray-900">
            Impacto real, medible y trazable.
          </h2>
        </div>
        <ul className={`grid gap-6 ${gridCols}`} data-testid="metrics-grid">
          {metrics.map((m) => (
            <li
              key={m.key}
              data-testid={`metric-public-${m.key}`}
              className="bg-white border border-gray-200 rounded-sm p-6 text-center hover:border-brand-burgundy transition-colors"
            >
              <div className="font-serif text-4xl sm:text-5xl text-brand-burgundy font-semibold leading-none mb-3">
                {(m.value ?? 0).toLocaleString("es-CO")}
                <span className="text-2xl text-brand-burgundy-light">{unitSuffix(m.unit)}</span>
              </div>
              <p className="text-xs uppercase tracking-[0.18em] text-gray-600 font-medium leading-snug">
                {m.label}
              </p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
